import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListSharedComponent } from './list.component';

import { IconSharedModule } from './../icon/icon.module';
import { FaIconSharedModule } from '../fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        ListSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        FaIconSharedModule
    ],
    exports: [
        ListSharedComponent
    ]
})

export class ListSharedModule {}
